module.exports = __webpack_public_path__ + "static/media/shirt-cooperate-1.3ead011e.jpg";